export default __webpack_public_path__ + "static/media/CNo.68-0.d4001ac0.jpg";